module.exports = __webpack_public_path__ + "img/pop-up.bf5550ae.svg";